import React from "react"
import useSearchContext, { SearchContextValue } from "./use-search-context"
import { useSearchSelector } from "./search-redux-context"

type UsePaginationReturn = {
  info: {
    pageNumber: number
    pageStart: number
    pageEnd: number
    pageSize: number
    pageCount: number
    resultCount: number
  }
  setPage(page: number): void
  setSize(size: number): void
  search(): void
}
export default function usePagination(
  searchMethods?: SearchContextValue,
): UsePaginationReturn {
  const { pagination, search } = useSearchContext(searchMethods)
  const info = useSearchSelector(pagination.select)
  const { setPage, setSize } = pagination

  return React.useMemo(
    () => ({ info, setPage, setSize, search }),
    [info, setPage, setSize, search],
  )
}
